import React, { useEffect } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Products from "./components/Products";
import Collaboration from "./components/Collaboration";
import Manifesto from "./components/Manifesto";
import Footer from "./components/Footer";
import "./App.css";

function App() {
  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -60px 0px" }
    );
    document.querySelectorAll("[data-reveal]").forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  useEffect(() => {
    const onMove = (e) => {
      const x = (e.clientX / window.innerWidth - 0.5) * 20;
      const y = (e.clientY / window.innerHeight - 0.5) * 20;
      document.documentElement.style.setProperty("--mx", `${x}px`);
      document.documentElement.style.setProperty("--my", `${y}px`);
    };
    window.addEventListener("mousemove", onMove);
    return () => window.removeEventListener("mousemove", onMove);
  }, []);

  return (
    <div className="app-shell">
      <div className="aurora" aria-hidden="true">
        <span className="aurora__a" />
        <span className="aurora__b" />
        <span className="aurora__c" />
        <div className="grid-veil" />
      </div>

      <Header />
      <main>
        <Hero />
        <Products />
        <Collaboration />
        <Manifesto />
      </main>
      <Footer />
    </div>
  );
}

export default App;
